import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  ButtonProps,
} from "@mui/material";
import { Close, PlayCircleOutline } from "@mui/icons-material";
import type { TutorialVideo } from "src/constants/tutorials";

interface TutorialVideoButtonProps {
  video: TutorialVideo;
  buttonLabel?: string;
  buttonProps?: ButtonProps;
}

export const TutorialVideoButton: React.FC<TutorialVideoButtonProps> = ({
  video,
  buttonLabel = "Assistir tutorial",
  buttonProps,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<PlayCircleOutline />}
        onClick={handleOpen}
        {...buttonProps}
      >
        {buttonLabel}
      </Button>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby={`tutorial-dialog-${video.id}`}
      >
        <DialogTitle id={`tutorial-dialog-${video.id}`} sx={{ pr: 6 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h6">{video.title}</Typography>
            <IconButton onClick={handleClose} aria-label="Fechar tutorial">
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={3}>
            <Box
              sx={{
                position: "relative",
                pt: "56.25%",
                width: "100%",
              }}
            >
              <Box
                component="iframe"
                src={`${video.embedUrl}?autoplay=1`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={video.title}
                sx={{
                  border: 0,
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: 1,
                }}
              />
            </Box>
            <Typography color="text.secondary">{video.description}</Typography>
            <Button
              href={video.shareUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="text"
              startIcon={<PlayCircleOutline />}
            >
              Assistir no Loom
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};
